<template>
  <div>
    <!-- Trilha de Auditoria -->
    <div class="panel panel-default" v-if="trilhaAuditoria">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Trilha de Auditoria</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item">
          <pre class="carimbo">{{ trilhaAuditoria }}</pre>
        </li>
      </ul>
    </div>

    <!-- Hash Assinado -->
    <div class="panel panel-default" v-if="detalhesEnvioEntregaSMS && detalhesEnvioEntregaSMS.hashAssinado">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Hash Assinado</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item">
          <strong>{{ detalhesEnvioEntregaSMS.hashAssinado }}</strong>
        </li>
      </ul>
    </div>

    <!-- Carimbo do Tempo -->
    <div class="panel panel-default" v-if="detalhesEnvioEntregaSMS && detalhesEnvioEntregaSMS.carimbo">
      <div class="panel-heading">
        <h3 class="panel-title text-primary">Carimbo do Tempo (Entrega)</h3>
      </div>
      <ul class="list-group">
        <li class="list-group-item" v-if="detalhesEnvioEntregaSMS.ocorridoEm">
          Ocorrido em: <strong>{{ formatarData(detalhesEnvioEntregaSMS.ocorridoEm) }}</strong>
        </li>
        <li class="list-group-item">
          <pre id="carimbo" style="margin-top: 10px;">{{ detalhesEnvioEntregaSMS.carimbo }}</pre>
        </li>
        <li class="list-group-item">
          Certificado pela Autoridade do Carimbo do tempo ICP-Brasil
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppInfoSMSSendDeliveryDetails',

  props: {
    detalhesEnvioEntregaSMS: {
      type: Object
    }
  },

  computed: {
    trilhaAuditoria () {
      if (!this.detalhesEnvioEntregaSMS || !this.detalhesEnvioEntregaSMS.trilhaAuditoriaSMS) {
        return ''
      }

      // A trilha já vem decodificada e sanitizada do backend
      return JSON.stringify(this.detalhesEnvioEntregaSMS.trilhaAuditoriaSMS, null, 2)
    },

    timestampAuthorityName () {
      const provider = this.detalhesEnvioEntregaSMS && this.detalhesEnvioEntregaSMS.provider
      if (provider === 'SAFEWEB') {
        return 'SAFEWEB'
      }
      return 'Bry Tecnologia'
    },

    timestampAuthorityUrl () {
      const provider = this.detalhesEnvioEntregaSMS && this.detalhesEnvioEntregaSMS.provider
      if (provider === 'SAFEWEB') {
        return 'https://www.safeweb.com.br/'
      }
      return 'https://www.bry.com.br/'
    }
  },

  methods: {
    formatarData (data) {
      if (!data) {
        return ''
      }

      // Se já está no formato correto (DD/MM/YYYY HH:mm:ss), retorna como está
      if (typeof data === 'string' && /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/.test(data)) {
        return data
      }

      // Se for uma string de data no formato Date.toString(), converte
      try {
        const date = new Date(data)
        if (isNaN(date.getTime())) {
          return data
        }

        const dia = String(date.getDate()).padStart(2, '0')
        const mes = String(date.getMonth() + 1).padStart(2, '0')
        const ano = date.getFullYear()
        const horas = String(date.getHours()).padStart(2, '0')
        const minutos = String(date.getMinutes()).padStart(2, '0')
        const segundos = String(date.getSeconds()).padStart(2, '0')

        return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`
      } catch (error) {
        return data
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/provider-sms/InfoSMSSendDeliveryDetails.vue